// upsell-carousel.js - Versión definitiva con ámbito local
(function() {
  // Buscar el contenedor principal del upsell
  const wrapper = document.querySelector('.upsell-carousel-wrapper');
  if (!wrapper) {
    console.warn('❌ Upsell: No se encontró .upsell-carousel-wrapper');
    return;
  }
  console.log('✅ Upsell: Wrapper encontrado');

  // Buscar el track dentro del wrapper
  const track = wrapper.querySelector('.upsell-carousel-track');
  if (!track) {
    console.warn('❌ Upsell: No se encontró .upsell-carousel-track');
    return;
  }
  console.log('✅ Upsell: Track encontrado');

  const slides = track.children;
  if (slides.length === 0) {
    console.warn('❌ Upsell: No hay slides');
    return;
  }
  console.log('✅ Upsell: Slides encontrados:', slides.length);

  // Botones y dots dentro del wrapper
  const prev = wrapper.querySelector('.upsell-carousel-prev');
  const next = wrapper.querySelector('.upsell-carousel-next');
  const dotsContainer = wrapper.querySelector('.upsell-carousel-dots');

  if (!dotsContainer) {
    console.warn('❌ Upsell: No se encontró .upsell-carousel-dots');
    return;
  }

  let currentIndex = 0;
  const totalSlides = slides.length;

  // Función para mover el slider
  function goTo(index) {
    if (index < 0) index = 0;
    if (index >= totalSlides) index = totalSlides - 1;
    currentIndex = index;
    track.style.transform = `translateX(-${currentIndex * 100}%)`;
    if (prev) prev.disabled = currentIndex === 0;
    if (next) next.disabled = currentIndex === totalSlides - 1;
    const dots = wrapper.querySelectorAll('.upsell-carousel-dot');
    dots.forEach((d, i) => d.classList.toggle('active', i === currentIndex));
    console.log('🔄 Upsell: slide', currentIndex + 1);
  }

  // Crear dots si no existen
  if (dotsContainer.children.length === 0) {
    for (let i = 0; i < totalSlides; i++) {
      const dot = document.createElement('div');
      dot.className = 'upsell-carousel-dot' + (i === 0 ? ' active' : '');
      dot.addEventListener('click', () => goTo(i));
      dotsContainer.appendChild(dot);
    }
  }

  // Asignar eventos a los botones usando el wrapper
  if (prev) {
    prev.addEventListener('click', function(e) {
      e.preventDefault();
      console.log('⬅️ Upsell: anterior');
      goTo(currentIndex - 1);
    });
  }
  if (next) {
    next.addEventListener('click', function(e) {
      e.preventDefault();
      console.log('➡️ Upsell: siguiente');
      goTo(currentIndex + 1);
    });
  }

  // Swipe táctil y ratón (igual que antes)
  let startX = 0, isDragging = false;
  track.addEventListener('touchstart', (e) => {
    startX = e.changedTouches[0].screenX;
    isDragging = true;
    track.style.transition = 'none';
  }, { passive: true });

  track.addEventListener('touchmove', (e) => {
    if (!isDragging) return;
    const diff = e.changedTouches[0].screenX - startX;
    track.style.transform = `translateX(calc(-${currentIndex * 100}% + ${diff}px))`;
  }, { passive: true });

  track.addEventListener('touchend', (e) => {
    if (!isDragging) return;
    isDragging = false;
    track.style.transition = 'transform 0.3s ease';
    const diff = e.changedTouches[0].screenX - startX;
    if (Math.abs(diff) > 50) goTo(diff > 0 ? currentIndex - 1 : currentIndex + 1);
    else goTo(currentIndex);
  }, { passive: true });

  let mouseDown = false, mouseStartX = 0;
  track.addEventListener('mousedown', (e) => {
    mouseDown = true;
    mouseStartX = e.screenX;
    track.style.transition = 'none';
    track.style.cursor = 'grabbing';
    e.preventDefault();
  });

  document.addEventListener('mousemove', (e) => {
    if (!mouseDown) return;
    const diff = e.screenX - mouseStartX;
    track.style.transform = `translateX(calc(-${currentIndex * 100}% + ${diff}px))`;
  });

  document.addEventListener('mouseup', (e) => {
    if (!mouseDown) return;
    mouseDown = false;
    track.style.transition = 'transform 0.3s ease';
    track.style.cursor = 'grab';
    const diff = e.screenX - mouseStartX;
    if (Math.abs(diff) > 50) goTo(diff > 0 ? currentIndex - 1 : currentIndex + 1);
    else goTo(currentIndex);
  });

  // Switch de upsells (dentro del wrapper)
  wrapper.querySelectorAll('.upsell-switch-input').forEach(sw => {
    sw.addEventListener('change', function() {
      wrapper.querySelectorAll('.upsell-switch-input').forEach(other => {
        if (other !== this) other.checked = false;
      });
    });
  });

  // Iniciar en slide 0
  goTo(0);
  window.addEventListener('resize', () => goTo(currentIndex));

  console.log('✅ Upsell carousel listo (ámbito local)');
})();